import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';
import { ICampaignTemplate } from 'queries/fetch/fetchCampaignTemplatesForTeam.ts';
import featureFlags from 'services/featureFlags.ts';
import { CampaignTemplate } from 'schemas/CampaignTemplates.schema';

interface IFetchCampaignTemplateVariables {
  teamId: string;
  campaignId: string;
  isEnabled: boolean;
}

export default function useFetchTemplateForCampaign({ teamId, campaignId, isEnabled }: IFetchCampaignTemplateVariables) {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['campaignTemplate', { teamId, campaignId }],
    enabled: featureFlags.campaignTemplates && isEnabled,
    queryFn: async () => {
      const response = await apiFetch<ICampaignTemplate>({
        path: `/team/${teamId}/campaign/${campaignId}/template`,
        method: 'GET',
        accessToken: String(tokens.accessToken),
      });

      return Object.fromEntries(response.properties.map(({ key, value }) => [key, value])) as CampaignTemplate;
    },
  });
}
